import { fromJS } from "immutable";

import TYPE from "../../constants/type";

const initialState = fromJS({
  list: [],
  listById: [],
  listFiltered: [],
  listDuplicate: [],
  isFetching: false,
  isFetchingAccepted: false,
});

export default function achievementReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_LOADING:
    case TYPE.ACHIEVEMENT.GET_FILTERED_ACHIEVEMENT_LOADING:
    case TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_BY_PROFILE_ID_LOADING:
    case TYPE.ACHIEVEMENT.INSERT_ACHIEVEMENT_LOADING:
    case TYPE.ACHIEVEMENT.UPDATE_ACHIEVEMENT_LOADING:
    case TYPE.ACHIEVEMENT.DELETE_ACHIEVEMENT_LOADING:
    case TYPE.ACHIEVEMENT.CHECK_DUPLICATE_ACHIEVEMENT_LOADING:
      return state.merge({
        isFetching: true,
      });

    case TYPE.ACHIEVEMENT.ACCEPT_ACHIEVEMENT_LOADING:
      return state.merge({
        isFetchingAccepted: true,
      });

    case TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_FAILURE:
    case TYPE.ACHIEVEMENT.GET_FILTERED_ACHIEVEMENT_FAILURE:
    case TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_BY_PROFILE_ID_FAILURE:
    case TYPE.ACHIEVEMENT.INSERT_ACHIEVEMENT_FAILURE:
    case TYPE.ACHIEVEMENT.UPDATE_ACHIEVEMENT_FAILURE:
    case TYPE.ACHIEVEMENT.DELETE_ACHIEVEMENT_FAILURE:
    case TYPE.ACHIEVEMENT.CHECK_DUPLICATE_ACHIEVEMENT_FAILURE:
      return state.merge({
        isFetching: false,
      });

    case TYPE.ACHIEVEMENT.ACCEPT_ACHIEVEMENT_FAILURE:
      return state.merge({
        isFetchingAccepted: false,
      });

    case TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_SUCCESS:
      return state.merge({
        list: action.payload || [],
        isFetching: false,
      });

    case TYPE.ACHIEVEMENT.GET_FILTERED_ACHIEVEMENT_SUCCESS:
      return state.merge({
        listFiltered: action.payload || [],
        isFetching: false,
      });

    case TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_BY_PROFILE_ID_SUCCESS:
      return state.merge({
        listById: [...action.payload],
        isFetching: false,
      });

    case TYPE.ACHIEVEMENT.INSERT_ACHIEVEMENT_SUCCESS: {
      const newlistById = state.get("listById");
      const index = action.payload.achievementProfile.findIndex((e) => e.profileId === action.id);
      if (index >= 0) newlistById.push({ achievement: action.payload });
      return state.merge({
        listById: [...newlistById],
        listFiltered: [...state.get("listFiltered"), { achievement: action.payload }],
        isFetching: false,
      });
    }

    case TYPE.ACHIEVEMENT.UPDATE_ACHIEVEMENT_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.achievement.id === action.id);
      newList.splice(index, 1, { achievement: action.payload });

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.achievement.id === action.id);
      newList1.splice(index1, 1, { achievement: action.payload });

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.ACHIEVEMENT.DELETE_ACHIEVEMENT_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.achievement.id === action.id);
      if (index !== -1) newList.splice(index, 1);

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.achievement.id === action.id);
      if (index1 !== -1) newList1.splice(index1, 1);

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.ACHIEVEMENT.ACCEPT_ACHIEVEMENT_SUCCESS: {
      const newList = state.get("listById");
      const index = newList.findIndex((e) => e.achievement.id === action.payload.id);
      const newAchievement = { ...newList[index], achievement: action.payload };
      newList.splice(index, 1, newAchievement);

      const newList1 = state.get("listFiltered");
      const index1 = newList1.findIndex((e) => e.achievement.id === action.payload.id);
      const newAchievement1 = { ...newList1[index1], achievement: action.payload };
      newList1.splice(index1, 1, newAchievement1);

      return state.merge({
        listById: [...newList],
        listFiltered: [...newList1],
        isFetchingAccepted: false,
      });
    }

    case TYPE.ACHIEVEMENT.CHECK_DUPLICATE_ACHIEVEMENT_SUCCESS:
      return state.merge({
        listDuplicate: action.payload || [],
        isFetching: false,
      });

    default:
      return state;
  }
}

